import { render, staticRenderFns } from "./dangerousGoodsStorageLocation.vue?vue&type=template&id=389f1512"
import script from "./dangerousGoodsStorageLocation.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsStorageLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports